import { SplitMatrixModel } from './split-matrix.model';
import { BaseModel, Default } from '@red/data-access';
import { Expose, Transform, Type } from 'class-transformer';
import { PersonalParticularModel } from './personal-particular.model';
import { AppointmentTypeModel } from './appointment-type.model';
import { IProjectTransactionBonus } from '../interfaces/project-transaction-bonus.interface';
import { SplitPartModel } from './split-part.model';
import { CategoryModel } from './category.model';
import { EAgentSession } from '../enums/agent-session.enum';

export class ProjectTransactionBonusModel extends BaseModel implements IProjectTransactionBonus {
  @Expose()
  @Expose({ groups: ['full'] })
  id!: number;

  @Expose()
  @Expose({ groups: ['full'] })
  appointmentTypeId!: number;

  @Expose()
  @Expose({ groups: ['full'] })
  @Type(() => AppointmentTypeModel)
  appointmentType!: AppointmentTypeModel;

  @Expose()
  @Expose({ groups: ['full'] })
  appTypeCode!: string;

  @Expose()
  @Expose({ groups: ['full'] })
  salespersonId!: number;

  @Expose()
  @Expose({ groups: ['full'] })
  @Type(() => PersonalParticularModel)
  @Transform(({ obj, value }) => {
    if (!value || !value?.id) {
      return obj?.tiers?.[0]?.salesperson;
    }
    return value;
  })
  salesperson!: PersonalParticularModel;

  @Expose()
  @Expose({ groups: ['full'] })
  splitMatrixId!: number;

  @Expose()
  @Expose({ groups: ['full'] })
  @Type(() => SplitMatrixModel)
  splitMatrix!: SplitMatrixModel;

  @Expose()
  @Expose({ groups: ['full'] })
  receivedDirectPercent!: number;

  @Expose()
  @Expose({ groups: ['full'] })
  receivedPercent!: number;

  @Expose()
  @Expose({ groups: ['full'] })
  receivedValue!: number;

  @Expose()
  @Expose({ groups: ['full'] })
  transactedPercent!: number;

  @Expose()
  @Expose({ groups: ['full'] })
  transactedValue!: number;

  @Expose()
  agentType!: EAgentSession;

  @Expose()
  grouping!: string;

  @Expose()
  @Transform(({ value }) => {
    if (!value || value.length === 0) {
      return [
        {
          name: 'Commission',
          level: 1,
        },
        {
          name: 'Tier 1',
          level: 2,
        },
        {
          name: 'Tier 2',
          level: 3,
        },
      ];
    }
    return value;
  })
  @Type(() => SplitPartModel)
  tiers!: SplitPartModel[];

  @Expose({ groups: ['full', 'summary'] })
  @Transform(({ value }) => {
    if (!value || value.length === 0) {
      return [
        {
          name: 'Recruiter',
          level: 4,
        },
      ];
    }
    return value;
  })
  @Type(() => SplitPartModel)
  parties!: SplitPartModel[];

  @Expose({ groups: ['full', 'summary'] })
  totalAmount!: number;

  @Expose({ groups: ['full', 'summary'] })
  @Transform(({ obj }) => {
    return obj?.receivedValue - obj?.totalAmount;
  })
  companyAmount!: number;

  @Expose()
  @Expose({ groups: ['full'] })
  createdAt!: string;

  @Expose()
  @Expose({ groups: ['full'] })
  updatedAt!: string;

  @Expose()
  attrs!: {
    [key: string]: any;
  };
}
